<script setup lang="ts">
import { CircleXIcon, MailIcon } from "vue-tabler-icons";
import { Icon } from "@iconify/vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/stores/user/index";
import { usePermissionStore } from "@/stores/permission/index";
import { RoleType } from "~/types/permission/Types";

const { t } = useI18n();

const permissionStore = usePermissionStore();
var { rolePermission } = permissionStore;
var role = '';
switch (rolePermission?.role) {
  case RoleType.Operator:
    role = rolePermission.role2;
    if (role == 'operator') role = 'callcenter operator';
    break;
  case RoleType.Agent:
    role = ''
    break;
  default:
    role = 'admin';
    break;
};

const logOut = async () => {
  const userStore = useUserStore();
  const accessToken = useCookie("accessToken");
  const adminNumber = useCookie("adminNumber");
  accessToken.value = null;
  adminNumber.value = null;
  await userStore.logOut();
  // navigateTo("/auth/login");
  reloadNuxtApp({ path: "/auth/login", ttl: 100 });
};

const userInformation = computed(() => {
  const phone = useCookie("adminNumber");
  return phone.value;
});
</script>

<template>
  <!-- ---------------------------------------------- -->
  <!-- notifications DD -->
  <!-- ---------------------------------------------- -->
  <v-menu :close-on-content-click="true" class="profile_popup">
    <template v-slot:activator="{ props }">
      <div
        class="custom-hover-primary text-left px-0 cursor-pointer"
        variant="text"
        v-bind="props"
      >
        <div class="d-flex align-center">
          <v-avatar size="32">
            <img src="/images/profile/user6.jpg" width="32" :alt="$t('Navatel')" />
          </v-avatar>
        </div>
      </div>
    </template>
    <v-sheet rounded="lg" width="385" elevation="10" class="mt-5">
      <div class="px-8 pt-6">
        <div class="d-flex align-center justify-space-between">
          <h6 class="text-h5 font-weight-semibold">{{ $t("User Profile") }}</h6>
          <CircleXIcon
            size="22"
            class="text-grey100 cursor-pointer opacity-50"
          />
        </div>

        <div class="d-flex align-center mt-5 pb-3">
          <v-avatar size="90">
            <img src="/images/profile/user6.jpg" width="90" />
          </v-avatar>
          <div class="ml-5">
            <h6 class="text-h5 mb-n1">{{ userInformation }}</h6>
            <span class="text-subtitle-1 font-weight-regular text-grey100 font-weight-medium">{{ $t(role) }}</span>
          </div>
        </div>
        <v-divider></v-divider>
      </div>
      <div class="pb-6 px-8 mt-3 text-center">
        <v-btn
          color="primary"
          size="large"
          rounded="pill"
          block
          @click="logOut"
          >{{ $t("Logout") }}</v-btn
        >
      </div>
    </v-sheet>
  </v-menu>
</template>
